import React, { useState, useEffect, Fragment } from 'react'
import axios from 'axios'
import { Table } from 'reactstrap'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'
import houseRules from './house-rules.png'

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faEdit, faLocationArrow, faTrash } from '@fortawesome/free-solid-svg-icons';

import './AGM.css'

const appScriptUrl = 'https://script.google.com/macros/s/AKfycbzk3Fs00t31erD9J3Q5G8YuT5SaoDDX6nQPLVurkizNwgXZZw7QKknOnb-nDH6Yq0GG/exec'

const EventList = props => {
    const [event, setEvent] = useState(null)
    const [email, setEmail] = useState(null)
    const [emails, setEmails] = useState([])
    //Getting all Events using axios
    useEffect(() => {
        getEmails()
        getEvent()
    }, [])

    const getEvent = async () => {
        await axios.get('/api/events/60aa1a17e5b18c0017bfc041', tokenConfig())
            .then(res => setEvent(res.data))
            .catch(err => console.log(err))
    }

    const getEmails = async () => {
        const { data } = await axios.get(appScriptUrl)
        const emails = data.sort().map(e => e[0])
        setEmails(emails)
    }

    const confirmAttendance = async () => {
        const { data } = await axios.post('/api/events/agm', { email }, tokenConfig())
        if (data === 'Success') {
            console.log('SUccessfulsafhjk')
            window.alert(`Your Attendance Has been Captured for email: ${email}`)
        }
    }

    if (!event) return <div></div>
    return (
        <Fragment>
            <div className='agm-page'>
                <div className='agm-display-wrapper'>
                    <p style={{
                        fontSize: '12px',
                        textAlign: 'right'
                    }}>
                        If you don't find your email in the list, please message use in the google meeting chat
                                    </p>
                    <div className='agm-header-wrapper'>
                        <div className='agm-header-text-wrapper'>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div className='agm-header-title'>{event.name}</div>
                                <span style={{ marginTop: '0.2rem', }}>
                                    {/* <span style={{ fontWeight: "bold" }}>Location</span><br></br>  */}
                                    <FontAwesomeIcon icon={faLocationArrow} /> &nbsp;
                                <span style={{ whiteSpace: "pre-wrap" }}><a style={{ color: 'inherit', fontWeight: '500', fontSize: '18px' }} target='blank' href={event.location}>Google Meets</a></span>
                                </span>
                                <span style={{ marginTop: '0.2rem', }}>
                                    {/* <span style={{ fontWeight: "bold" }}>Date</span><br></br> */}
                                    <FontAwesomeIcon icon={faCalendar} /> &nbsp;
                                <span style={{ whiteSpace: "pre-wrap", fontSize: '18px' }}>{new Date(event.date).toLocaleDateString()}</span>
                                </span>
                            </div>
                            <div className='agm-select-wrapper'>
                                <select
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    className='agm-select'
                                    disabled={emails.length > 0 ? false : true}
                                >
                                    <option>Select Your Email</option>
                                    {emails.map(email => <option>{email}</option>)}
                                </select>
                                <button
                                    onClick={confirmAttendance}
                                    className={`agm-confirm-button ${!email && 'agm-disabled'}`}
                                    disabled={email ? false : true}
                                >Confirm Attendance</button>
                            </div>
                        </div>
                    </div>
                    <div className='agm-content-wrapper'>
                        {/* <div className='agm-countdown'>
                            <img style={{
                                width: '100%',
                                maxWidth: '350px'
                            }}
                                src="http://gen.sendtric.com/countdown/h4vsqomhzt" />
                        </div> */}
                        <div className='agm-schedule-wrapper'>
                            <div className='agm-schedule-title'>Agenda</div>
                            <p style={{ whiteSpace: "pre-wrap" }}>
                                {event.description}
                            </p>
                        </div>
                        <div className='agm-countdown'>
                            <img style={{
                                width: '100%',
                                maxWidth: '350px'
                            }}
                                src={houseRules} />
                        </div>
                    </div>
                </div>

            </div>

        </Fragment>
    )
}

export default EventList